import OrgView from './OrgView';
import Header from '../components/Header';
import { ThemeProvider } from '../containers/ThemeProvider';
import './index.css';
import MainArea from './MainArea';
import { BrowserRouter, Route, Routes } from 'react-router';
import { EditingContextPrimed } from '../containers/EditingContext';
import { checkJWTNotExpired } from 'utils/jwtAuthTools';
import { Toaster } from 'components/ui/sonner';
import { AlertCircle } from 'lucide-react';

const MainApp = () => {
  const jwtExpired = !checkJWTNotExpired();

  return (
    <ThemeProvider attribute="class" defaultTheme="system" enableSystem disableTransitionOnChange>
      {jwtExpired ? (
        <div className="flex justify-center m-50">
          <h2>Expired login</h2>
        </div>
      ) : (
        <EditingContextPrimed>
          <BrowserRouter>
            <Header />
            <div className="flex justify-center">
              <div className="w-full lg:w-300 xl:w-380 h-full p-8">
                <Routes>
                  <Route index element={<MainArea />} />
                  <Route path="organization/:orgId" element={<OrgView />} />
                </Routes>
              </div>
            </div>
          </BrowserRouter>
          <Toaster
            visibleToasts={10}
            position="top-center"
            closeButton
            icons={{
              error: (
                <div>
                  <AlertCircle size={20} />
                </div>
              ),
            }}
            toastOptions={{ duration: 15000 }}
          />
        </EditingContextPrimed>
      )}
    </ThemeProvider>
  );
};

export default MainApp;
